import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import { getVitalOptionsSelector } from '../../options/selectors'
import { IVitalOptionsState } from '../../options/store/options.types'

export function* setTitrateQuickAction() {
  const userId: string = yield select(getUserIdSelector)
  const quickActionsState = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsState
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate } = props
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)
  yield put({ type: 'titrate/SET_DATE_TIME', date: currentDate, time: savedTimeString })
  yield put({ type: 'titrate/SET_ASSESSED_BY', assessedBy: assessedByOption ? assessedByOption : null })
}

export function* setTitrateQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_TITRATE_BUTTON_TYPE], setTitrateQuickAction)
}
